module.exports = __webpack_public_path__ + "img/02_es_mi_meg_igy_is_tovab_elunk-02 copy.7889687c.jpg";